export const style = {
  new: {
    display: `block`,
    cursor: `pointer`,
    fontSize: `12px`,
    color: `white`,
    background: `#AD5251`,
    padding: `5px 25px`,
    border: `2px solid #AD5251`,
    textDecoration: `none`,
    textAlign: `center`,
    margin: `10px -15px`,
    '@media (min-width: 1200px)': {
      margin: `auto`
    },
    ':hover': {
      background: `white`,
      color: `#AD5251`
    }
  },
  fullWidth: {
    '@media (min-width: 1200px)': {
      margin: `10px -15px`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/buttons.js